export const EndpointMethods = {
    ReplaceExistingPhotoRequest: '/update',
    ActiveBadge: '/ActiveBadge',
    RemoveBackground: '/RemoveBackground',
    LoginWithWwId: '/LoginWithWwId',
    LoginWithAzure: '/LoginWithAzure',
}
